var _path, _path2, _defs, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    width: 1000,
    height: 623,
    viewBox: "0 0 1000 623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.6060606060606233,0.2522267206477409)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 396 247",
    "data-background-color": "#050816",
    preserveAspectRatio: "xMidYMid meet",
    height: 623,
    width: 1000,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(1,0,0,1,0.2400000000000091,-0.09999999999999432)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 247.2",
    height: 247.2,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 247.2",
    height: 247.2,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M113.006 247.2c-2.59 0-4.591-0.777-6.004-2.331-1.413-1.507-2.119-3.437-2.119-5.791v-49.454h34.608v49.454c0 2.354-0.753 4.285-2.26 5.791-1.554 1.554-3.626 2.331-6.215 2.331zM104.883 8.475c0-2.59 0.706-4.661 2.119-6.215 1.413-1.507 3.414-2.26 6.004-2.26h86.167c26.603 0 47.674 6.239 63.212 18.717 11.811 9.485 19.133 22.438 21.966 38.859l-36.222 0c-2.085-6.692-5.62-12.229-10.605-16.611-8.617-7.534-21.871-11.301-39.764-11.301h-58.269v27.912l-34.608 0zM289.577 236.253c0.706 1.413 1.059 2.707 1.06 3.884 0 1.883-0.753 3.531-2.261 4.944-1.554 1.413-3.272 2.119-5.155 2.119h-16.951c-4.002 0-6.945-1.059-8.829-3.178-1.883-2.119-3.531-4.238-4.944-6.357l-27.425-48.041 37.51 0z",
    fill: "#804dee",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    },
    "data-fill-palette-color": "tertiary"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,72.491888011486)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 102.21622397702798",
    height: 102.21622397702798,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 102.21622397702798",
    height: 102.21622397702798,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 102.21622397702798",
    height: 102.21622397702798,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 102.21622397702798",
    height: 102.21622397702798,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "textblocktransform"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 102.21622397702798",
    height: 102.21622397702798,
    width: 395.52,
    id: "textblock",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 102.21622397702798",
    height: 102.21622397702798,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    viewBox: "4.35 -35.5 139.29 36",
    height: 102.21622397702798,
    "data-palette-color": "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    viewBox: "0 0 0 0",
    height: 7.92,
    "data-palette-color": "#ffffff",
    id: "scriptelement",
    x: 143.64,
    y: -35.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0",
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "#ffffff",
    className: "undefined-123",
    id: "av-123"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05 0L5.5 0Q4.95 0 4.65-0.33 4.35-0.65 4.35-1.15L4.35-1.15 4.35-33.8Q4.35-34.35 4.65-34.68 4.95-35 5.5-35L5.5-35 17.7-35Q23.35-35 26.65-32.35 29.95-29.7 29.95-24.5L29.95-24.5Q29.95-20.65 28.03-18.23 26.1-15.8 22.8-14.85L22.8-14.85 30.5-1.55Q30.65-1.25 30.65-1L30.65-1Q30.65-0.6 30.33-0.3 30 0 29.6 0L29.6 0 27.2 0Q26.35 0 25.95-0.45 25.55-0.9 25.25-1.35L25.25-1.35 18-14.05 9.25-14.05 9.25-1.15Q9.25-0.65 8.93-0.33 8.6 0 8.05 0L8.05 0ZM9.25-30.8L9.25-18.3 17.5-18.3Q21.25-18.3 23.1-19.88 24.95-21.45 24.95-24.55L24.95-24.55Q24.95-27.6 23.13-29.2 21.3-30.8 17.5-30.8L17.5-30.8 9.25-30.8ZM49.7 0.5L49.7 0.5Q45.4 0.5 42.35-0.98 39.3-2.45 37.65-5.53 36-8.6 35.8-13.25L35.8-13.25Q35.75-15.45 35.75-17.48 35.75-19.5 35.8-21.7L35.8-21.7Q36-26.3 37.72-29.38 39.45-32.45 42.52-33.98 45.6-35.5 49.7-35.5L49.7-35.5Q53.75-35.5 56.82-33.98 59.9-32.45 61.65-29.38 63.4-26.3 63.55-21.7L63.55-21.7Q63.65-19.5 63.65-17.48 63.65-15.45 63.55-13.25L63.55-13.25Q63.4-8.6 61.72-5.53 60.05-2.45 57-0.98 53.95 0.5 49.7 0.5ZM49.7-3.75L49.7-3.75Q53.5-3.75 55.92-6.05 58.35-8.35 58.55-13.5L58.55-13.5Q58.65-15.75 58.65-17.53 58.65-19.3 58.55-21.5L58.55-21.5Q58.45-24.95 57.27-27.1 56.1-29.25 54.15-30.25 52.2-31.25 49.7-31.25L49.7-31.25Q47.2-31.25 45.25-30.25 43.3-29.25 42.12-27.1 40.95-24.95 40.8-21.5L40.8-21.5Q40.75-19.3 40.75-17.53 40.75-15.75 40.8-13.5L40.8-13.5Q41-8.35 43.45-6.05 45.9-3.75 49.7-3.75ZM74.64 0L72.09 0Q71.55 0 71.25-0.33 70.94-0.65 70.94-1.15L70.94-1.15 70.94-33.8Q70.94-34.35 71.25-34.68 71.55-35 72.09-35L72.09-35 74.64-35Q75.19-35 75.52-34.68 75.84-34.35 75.84-33.8L75.84-33.8 75.84-20 93.05-20 93.05-33.8Q93.05-34.35 93.37-34.68 93.69-35 94.19-35L94.19-35 96.75-35Q97.3-35 97.62-34.68 97.94-34.35 97.94-33.8L97.94-33.8 97.94-1.15Q97.94-0.65 97.62-0.33 97.3 0 96.75 0L96.75 0 94.19 0Q93.69 0 93.37-0.33 93.05-0.65 93.05-1.15L93.05-1.15 93.05-15.5 75.84-15.5 75.84-1.15Q75.84-0.65 75.52-0.33 75.19 0 74.64 0L74.64 0ZM110.44 0L107.79 0Q107.24 0 106.94-0.33 106.64-0.65 106.64-1.15L106.64-1.15 106.64-33.85Q106.64-34.35 106.94-34.68 107.24-35 107.79-35L107.79-35 110.44-35Q110.99-35 111.29-34.68 111.59-34.35 111.59-33.85L111.59-33.85 111.59-1.15Q111.59-0.65 111.29-0.33 110.99 0 110.44 0L110.44 0ZM131.69 0L129.09 0Q128.59 0 128.27-0.33 127.94-0.65 127.94-1.15L127.94-1.15 127.94-30.55 118.34-30.55Q117.84-30.55 117.52-30.88 117.19-31.2 117.19-31.7L117.19-31.7 117.19-33.8Q117.19-34.35 117.52-34.68 117.84-35 118.34-35L118.34-35 142.44-35Q142.99-35 143.31-34.68 143.64-34.35 143.64-33.8L143.64-33.8 143.64-31.7Q143.64-31.2 143.31-30.88 142.99-30.55 142.44-30.55L142.44-30.55 132.89-30.55 132.89-1.15Q132.89-0.65 132.56-0.33 132.24 0 131.69 0L131.69 0Z",
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "#ffffff",
    className: "undefined-text-0",
    "data-fill-palette-color": "primary",
    id: "text-0"
  })))))))))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 395.52,
    height: 247.2,
    fill: "none",
    stroke: "none",
    visibility: "hidden"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6f9b0fd58a312448829f0706a1cef53e.svg";
export { ForwardRef as ReactComponent };